/**
 * Mobile menu drawer.
 * Open/close + body lock + escape + focus trap come from Drawer.
 * This subclass adds: hamburger trigger and aria-expanded sync.
 */
import { Drawer } from "@theme/drawer";

class HeaderDrawer extends Drawer {
  setup() {
    super.setup();
    this.openBtn = this.$("[data-open]");
    this.openBtn?.addEventListener("click", () => this.open());

    // The sticky header applies `backdrop-filter` when scrolled, which
    // creates a containing block for `position: fixed` descendants and
    // breaks the drawer's viewport positioning. Portal panel + overlay
    // out to <body> so they always anchor to the viewport.
    if (this.panel && this.panel.parentElement !== document.body) {
      document.body.appendChild(this.panel);
    }
    if (this.overlay && this.overlay.parentElement !== document.body) {
      document.body.appendChild(this.overlay);
    }
  }

  open() {
    super.open();
    this.openBtn?.setAttribute("aria-expanded", "true");
  }

  close() {
    if (!this.isOpen) return;
    super.close();
    this.openBtn?.setAttribute("aria-expanded", "false");
    this.openBtn?.focus();
  }
}

customElements.define("header-drawer", HeaderDrawer);

export { HeaderDrawer };
